import React from 'react';
import { SVGComponent } from '.';

const ChevronDown: SVGComponent = ({stroke = 'black'}) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.8095 8.09521L9.99995 11.9047L6.19043 8.09521"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ChevronDown;
